import { Language } from "./Language";

export enum OrganizationKind {
  Unspecified = "unspecified",
  Deployment = "deployment",
}

export type Organization = {
  id: number;
  label: string;
  defaultLanguage: Language;
  kind: OrganizationKind;
};

export type OrganizationUnit = {
  id: number;
  label: string;
  organizationId: number;
};

export type OrganizationUnitWithDetails = OrganizationUnit & {
  userCount: number;
  alarmRuleCount: number;
};

export type OrganizationWithUnits = {
  id: number;
  label: string;
  units?: OrganizationUnitWithDetails[];
};

export enum AlarmRuleType {
  HeaterErrorOrWarning = "heaterErrorOrWarning",
  HeaterMaintenance = "heaterMaintenance",
  HeaterService = "heaterService",
  HeaterAshLevel = "heaterAshLevel",
}

export type AlarmRule = {
  id: number;
  type: AlarmRuleType;
  organizationUnitId: number;
  params?: {
    value: number;
  };
  createdAt?: Date;
  updatedAt?: Date;
};

export type AlarmRulePayload = Pick<AlarmRule, "type" | "params">;
